// ** Lesson description: rich-text details for the active lesson (style-v3)
import React from "react";
import Box from "@mui/material/Box";

function Description({ content }) {
  if (content === undefined || content === null || content === "")
    return (
      <Box className="lesson-desc" sx={{ px: 4, pt: 2, pb: 4 }}>
        <div className="lesson-section-label">Detalhes</div>
        <p className="lesson-desc__empty">Não existem detalhes para esta aula.</p>
      </Box>
    );

  return (
    <Box className="lesson-desc" sx={{ px: 4, pt: 2, pb: 4 }}>
      <div className="lesson-section-label">Detalhes</div>
      <div
        className="lesson-html-content"
        style={{ fontSize: "1rem", lineHeight: 1.5 }}
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </Box>
  );
}

export default Description;
